import { FormType } from "libs/types/mhaForms";

export function isJointForm(type: FormType): boolean {
  return type === FormType.A3 || type === FormType.A7;
}
